export default __webpack_public_path__ + "static/media/Chestguard of the Victorious Elite.8cd5d545.jpg";